import React from 'react';

import { Modal, Table } from 'antd';

const SubLocationsModal = ({ show, setShow, data }) => {
  const Close = () => {
    setShow(false);
  };

  const columns = [
    {
      title: 'Name in English',
      align: 'center',
      render: rowData => {
        return rowData.nameEn;
      },
    },
    {
      title: 'Name in Arabic',
      align: 'center',
      render: rowData => {
        return <span className="arabic-field">{rowData.nameAr}</span>;
      },
    },
    {
      title: 'Address',
      align: 'center',
      render: rowData => {
        return data.node.mainLocationAddress
          ? data.node.governorate && data.node.area
            ? data.node.governorate + ' | ' + data.node.area
            : 'N/A'
          : rowData.governorate && rowData.area
          ? rowData.governorate + ' | ' + rowData.area
          : 'N/A';
      },
    },
  ];

  return (
    <Modal
      title={data.node.nameEn + ' | Sub-Locations List'}
      footer={null}
      open={show}
      onCancel={Close}
      width="800px"
    >
      <Table
        dataSource={data.node.subLocations}
        columns={columns}
        pagination={false}
        rowKey="id"
      />
    </Modal>
  );
};

export default SubLocationsModal;
